import React from "react";
import { motion } from "framer-motion";

export default function Modal({ open, onClose }) {
  const embedSrc = "https://forms.gle/nS4AfyEr1dEFAFve9";
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div onClick={onClose} className="absolute inset-0 bg-black/40 backdrop-blur-sm"></div>

      <motion.div initial={{scale:0.96, opacity:0}} animate={{scale:1, opacity:1}} transition={{duration:0.18}} className="relative z-50 w-full max-w-3xl rounded-2xl overflow-hidden bg-white dark:bg-[#041027] shadow-2xl border border-gray-100 dark:border-gray-800">
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100 dark:border-gray-800">
          <div className="text-sm font-semibold">Join FinBit Beta — Quick Survey</div>
          <button onClick={onClose} className="text-gray-600 dark:text-gray-300 px-2 py-1">✕</button>
        </div>

        <div className="p-0">
          <iframe title="FinBit Beta Form" src={embedSrc} className="form-iframe"></iframe>
        </div>
      </motion.div>
    </div>
  );
}
